import React from "react";
import Image from "gatsby-image";
import { ArticlePhotos } from "./ArticlePhotos";

export const ArticleData = () => {
  const images = ArticlePhotos();
  return {
    date: "27.11.2019r",
    category: "Black Friday",
    title: "Prawdziwie Czarny Piątek",
    description:
      "Gdy skończą się promocje na znicze i grobowe wiązanki, natychmiast zewsząd zaczyna atakować nas temat Czarnego Piątku. Black Friday Weekend, Black Friday Week, a czasem nawet i Black Friday Month - bo kto bogatemu zabronić mieć piątek przez cały miesiąc? Tradycja pochodząca ze Stanów Zjednoczonych przyszła do naszego kraju stosunkowo niedawno, ale jest forsowana z niesamowitym uporem. Czy jednak faktycznie kiedykolwiek zrozumiemy prawdziwy Czarny Piątek?",
    seo:
      "Gdy skończą się promocje na znicze i grobowe wiązanki, natychmiast zewsząd zaczyna atakować nas temat Czarnego Piątku.",
    slug: "/blog/prawdziwie_czarny_piatek",
    hero: (
      <Image
        alt=""
        objectPosition={"center"}
        objectFit={"contain"}
        fluid={images.hero.childImageSharp.fluid}
      />
    ),
    text: {
      first: {
        title: "Wyprzedaże wyzwalają krwiożercze instynkty",
        text: (
          <>
            Nazwa Black Friday nie wzięła się znikąd. To prawdziwie krwawy
            dzień. Jak pokazują statystyki, do tej pory już 12 ludzi straciło
            życie, a 117 zostało rannych podczas zakupowego szaleństwa na
            przestrzeni ostatnich 12 lat. Statystycznie mamy zatem jedną ofiarę
            śmiertelną w każdy Czarny Piątek! Uważajcie więc, kiedy następnym
            razem będziecie z jakąś matroną pojedynkować się o przecenioną
            markową torebkę.
          </>
        ),
      },
      second: {
        title: "",
        text: (
          <>
            A propos walki - jeżeli już planujecie bić się w sklepie o jakąś
            ekstra promocję - najlepszą bronią w tej dyscyplinie pozostaje gaz
            pieprzowy. W 2011 roku, na przykład, zapewnił on spektakularne
            zwycięstwo pewnej kobiecie w Walmarcie w Los Angeles. Dzięki niemu
            posłała do szpitala 20 rywali w walce o mocno przecenione konsole
            Xbox, gry na Wii i lalki Bratz.
          </>
        ),
      },
      third: {
        title: "",
        text: (
          <>
            Jeżeli chodzi o bardziej makabryczne efekty zakupowego szaleństwa,
            zawsze można liczyć na kobiety. W 2008 roku polała się krew, gdy
            dwie panie pobiły się w kalifornijskim sklepie z zabawkami
            Toys’R’Us. Towarzyszący im mężczyźni potraktowali tę bójkę naprawdę
            poważnie - obydwoje wyciągnęli broń i rozpoczęli strzelaninę.
            Obydwaj zginęli.
          </>
        ),
      },
      fourth: {
        title: "Tajemnicza choroba dnia wolnego",
        text: (
          <>
            Walki walkami, ale nie zapominajmy, że w Black Friday chodzi przede
            wszystkim o zakupy. Skąd jednak wzięła się coroczna tradycja bicia
            się o przecenione telewizory? Geneza tego dnia może być nieco
            zaskakująca. Święto Dziękczynienia obchodzone przez Amerykanów
            przypadało w ostatni czwartek listopada. Z tego powodu wielu ludzi w
            tajemniczy sposób zawsze chorowało w piątek po tym wolnym dniu.
          </>
        ),
      },
      fifth: {
        title: "",
        text: (
          <>
            Na drogach tworzyły się gigantyczne korki, gdy ciężko chorzy jechali
            w ten dzień do sklepów. Właśnie z powodu nadzwyczajnego ruchu i
            zagadkowego wirusa, który wszystkich dopadał, powstała nazwa Black
            Friday - i przyjęła się. Wtedy też pojawił się pomysł, aby uznać to
            za początek okresu zakupów przedświątecznych i prowadzenia w tym
            dniu wyprzedaży. Wizja dużych zysków doprowadziła nawet do
            przesunięcia daty Święta Dziękczynienia - na każdy czwarty czwartek
            listopada, a nie ostatni, aby zbytnio nie skracać czasu na
            bożonarodzeniowe zakupy.
          </>
        ),
      },

      sixth: {
        title: "Czarny Piątek zaczyna się w czwartek",
        text: (
          <>
            Do tej pory Black Friday zyskał międzynarodowy rozdźwięk. Nie
            dotyczy już jedynie krajów, gdzie obchodzi się tzw. Thanksgiving,
            ale opanował też Europę. Niestety, nasze rodzime promocje nie mogą
            się równać z tymi amerykańskimi i raczej przypominają ich
            karykaturę. Jednak nie tylko u nas powstają miesiące wyprzedaży,
            Black Friday Weeks i inne tego typu twory. W USA również Czarny
            Piątek przestaje mieć jedynie 24 godziny.
          </>
        ),
      },
      seventh: {
        title: "",
        text: (
          <>
            Najwięksi gracze na amerykańskim rynku prześcigają się w tym, kto
            pierwszy rozpocznie szaleństwo. Najpierw to była godzina szósta,
            piąta, czwarta rano, potem północ, a teraz już sklepy zostają
            otwarte jeszcze w Święto Dziękczynienia. Kmart - trzecia pod
            względem wielkości sieć handlowa w USA - rozpoczyna sprzedaż już o
            godzinie 6 rano. Z powodu tych praktyk, Święto Dziękczynienia
            zaczyna być nazywane Grey Thursday (ang. Szary Czwartek).
          </>
        ),
      },
      eigth: {
        title: "Najbardziej pracowity dzień dla… hydraulików",
        text: (
          <>
            Jak daleko jeszcze zajdziemy? Nie wiadomo. Powstają inicjatywy
            anty-czarnopiątkowe takie jak Buy Nothing Day, którego organizatorzy
            zachęcają do nierobienia zakupów w Black Friday. To idea jednak
            sporo młodsza i znacznie mniej znana. Na razie wciąż jeszcze Czarny
            Piątek oznacza zakupowe szaleństwo. I mnóstwo pracy dla hydraulików,
            dla których to najpracowitszy dzień w roku z powodu wielkiego
            obżarstwa w Dzień Dziękczynienia.
          </>
        ),
      },
      ninth: {
        title: "",
        text: (
          <>
            I choć Black Friday wciąż nam się będzie kojarzył z wyprzedażami i
            ogromnymi zyskami dla sklepów, nie zapominajmy, że jego obroty są
            niczym w porównaniu z chińskim Dniem Singla 11 listopada.
            Najbardziej pracowitym dla sprzedawców dniem w roku pozostaje zaś
            ostatnia sobota przed Świętami Bożego Narodzenia.
          </>
        ),
      },
    },
  };
};
